import PackageListItem, { PackageListItemSkeleton } from "./PackageListItem";
import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Skeleton } from "@material-ui/lab";
import { HTMLCarousel, HTMLCarouselItem, } from "../../../../Components/HTMLCarousel";
const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
    },
    carousel: {
        flexGrow: 1,
        scrollSnapType: "x mandatory",
        scrollBehavior: "smooth",
        overflowY: "hidden",
        overflowX: "scroll",
        display: "flex",
    },
    carouselItem: {
        scrollSnapAlign: "center",
        minWidth: "80vw",
        margin: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
    },
    bulletList: {
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
        justifyContent: "center",
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        "& a": {
            display: "block",
            width: "8px",
            height: "8px",
            backgroundColor: theme.palette.primary.light,
            marginRight: theme.spacing(1),
            borderRadius: "50%",
        },
    },
    skeletonBulletContainer: {
        width: "8px",
        height: "8px",
        marginRight: theme.spacing(1),
    },
    activeBullet: {
        "& a": {
            backgroundColor: theme.palette.secondary.main,
        },
    },
}));
const TestCarouselBulletsSkeleton = () => {
    const classes = useStyles();
    return (React.createElement("ul", { className: classes.bulletList }, [...Array(3).keys()].map((dummy, index) => {
        return (React.createElement("li", null,
            React.createElement("div", { className: classes.skeletonBulletContainer },
                React.createElement(Skeleton, { variant: "circle", width: 8, height: 8 }))));
    })));
};
const PackageList = ({ packageInfo }) => {
    const classes = useStyles();
    return (React.createElement("div", { className: classes.root },
        React.createElement(HTMLCarousel, { forwardRef: undefined }, packageInfo.packages.map((pkg, index) => {
            return (
            // @ts-ignore FIXME forwardKeys are added by HTMLCarousel(?)
            React.createElement(HTMLCarouselItem, { key: pkg.uuid },
                React.createElement(PackageListItem, { pkg: pkg })));
        }))));
};
export const PackageListSkeleton = () => {
    const classes = useStyles();
    // @ts-ignore
    return (React.createElement("div", { className: classes.root },
        React.createElement(HTMLCarousel, { forwardRef: undefined },
            React.createElement(HTMLCarouselItem, null,
                React.createElement(PackageListItemSkeleton, null)),
            React.createElement(HTMLCarouselItem, null,
                React.createElement(PackageListItemSkeleton, null)))));
};
export default PackageList;
